import { render } from "./UploadPageProgress.vue?vue&type=template&id=0b8159b8&scoped=true&ts=true"
import script from "./UploadPageProgress.vue?vue&type=script&lang=ts"
export * from "./UploadPageProgress.vue?vue&type=script&lang=ts"

import "./UploadPageProgress.vue?vue&type=style&index=0&id=0b8159b8&scoped=true&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8159b8"]])

export default __exports__